import { useRouter } from 'next/router';

import { type ListingSuggestion } from './listingSearch';
import { portalListingPath } from './portalPages';

/**
 * Shared handoff from an inventory search to a listing page: navigate to the
 * legacy-shaped slug URL.
 */
export const useListingNavigation = () => {
  const router = useRouter();
  return (listing: ListingSuggestion) => {
    void router.push(portalListingPath(listing.slug));
  };
};
